:host {
  display: block;
}

.wishlist {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  cursor: pointer;

  .heart,
  .heartFilled {
    width: 20px;
  }
}
